import React, { useState } from "react";
import { X, Star } from "lucide-react";
import "./ReviewModal.css";
import { showToast } from "../../utils/toast";
import { track } from "../../analytics/track";
import { EVENTS } from "../../analytics/events";

const ReviewModal = ({ isOpen, onClose, onSubmit, sellerName, orderId }) => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (rating === 0) {
      showToast.error("Please select a rating");
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit({ rating, comment, orderId });
      track(EVENTS.SELLER_RATING_SUBMITTED, {
        order_id: orderId,
        rating_value: rating,
        has_review: !!comment,
      });
      onClose();
    } catch (error) {
      console.error("Review submission error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSkip = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="review-modal-backdrop" onClick={handleSkip} />
      <div className="review-modal">
        <div className="review-modal-header">
          <h2 className="review-modal-title">Rate Your Experience</h2>
          <button className="review-modal-close" onClick={handleSkip}>
            <X size={20} />
          </button>
        </div>

        <div className="review-modal-content">
          <p className="review-seller-label">
            How was your in-person transaction with{" "}
            <span className="review-seller-name">{sellerName}</span>?
          </p>

          {/* Star Rating */}
          <div className="review-stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                type="button"
                className="review-star-btn"
                onMouseEnter={() => setHoverRating(star)}
                onMouseLeave={() => setHoverRating(0)}
                onClick={() => setRating(star)}
              >
                <Star
                  size={36}
                  className={`review-star ${
                    star <= (hoverRating || rating)
                      ? "review-star-filled"
                      : ""
                  }`}
                  fill={star <= (hoverRating || rating) ? "currentColor" : "none"}
                />
              </button>
            ))}
          </div>

          {rating > 0 && (
            <p className="review-rating-text">
              {rating === 1 && "Poor"}
              {rating === 2 && "Fair"}
              {rating === 3 && "Good"}
              {rating === 4 && "Very Good"}
              {rating === 5 && "Excellent"}
            </p>
          )}

          {/* Comment */}
          <div className="review-comment-section">
            <label htmlFor="review-comment" className="review-comment-label">
              Share your experience (optional)
            </label>
            <textarea
              id="review-comment"
              className="review-comment-textarea"
              rows={4}
              placeholder="Tell us about your experience with this seller..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              maxLength={500}
            />
            <span className="review-comment-count">{comment.length}/500</span>
          </div>

          {/* Actions */}
          <div className="review-modal-actions">
            <button
              className="review-submit-btn"
              onClick={handleSubmit}
              disabled={rating === 0 || isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit Review"}
            </button>
            <button className="review-skip-btn" onClick={handleSkip}>
              Skip for Now
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewModal;
